import styled from 'styled-components'
import SvgIcon from 'Components/SvgIcon'
import {
  SURFACE_INVERT,
  SURFACE_SECONDARY,
  BORDER_PRIMARY,
  TEXT_ERROR,
} from '@CSSVars/colors'

export const _GoogleBtn = styled.div`
   display: flex;
   padding: 16px;
   justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  height: 44px;
  width: 100%;
  p {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
    :active {
        p {
          color: white;
        }
      
    }
  border: 1px solid ${BORDER_PRIMARY};
  border-radius: 10px;
  cursor: pointer;
  :hover {
    background: ${SURFACE_SECONDARY};
  }
  :active {
    background: ${SURFACE_INVERT};
  }

`

export const _GoogleIcon = styled(SvgIcon)``

export const _ErrorMsg = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${TEXT_ERROR};
`

export const _GSIButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

`
